import React from 'react';
import "../assets/css/main_block.css";
import Header from './Header';
import { useTranslation } from 'react-i18next';
import stoneImg from '../assets/img/stone_cube.png';
import { useNavigate } from "react-router-dom";

function Main({ isAdmin }) {
  const [t, i18n] = useTranslation("global");
  const navigate = useNavigate();

  const handleOrderClick = () => {
    navigate(`/communication`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Header isAdmin={isAdmin} />

      <section className="main-block">
        <div className="main-block__inner">
          <div className="main-block__text">
            <h1 className="main-block__title">
              {t("main.motto")}
            </h1>
            <p className="main-block__desc">
              {t("main.description")}
            </p>
            <button className="main-block__btn" onClick={() => handleOrderClick()}>
              {t("main.orderButtonText")}
            </button>
          </div>

          <div className="main-block__image">
            <img src={stoneImg} alt="Stone block" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Main;
